module.exports = __webpack_public_path__ + "static/media/BannerActDatos.58020e6a.png";